import { HomeOutlined, ArrowBackOutlined, ArrowForwardOutlined, HelpOutline, InfoOutline, PeopleOutlined, ShoppingCartOutlined } from '@mui/icons-material';
import { Stack, Divider, Typography, Grid, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Asiakas } from '@/components/KoriList/KoriDetailsTabs';
import SiivousStatus from '@/components/VastaanottoVaraukset/SiivousStatus';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

const DetailsBody = ({ data, details, onToggleStatus, showSiivous }) => {
  if (!details || !details.type) return null;

  const { t } = useTranslation();

  const [localStatus, setLocalStatus] = useState({
    saapunut: details?.saapunut,
    lahtenyt: details?.lahtenyt,
  });

  useEffect(() => {
    setLocalStatus({
      saapunut: details?.saapunut,
      lahtenyt: details?.lahtenyt,
    });
  }, [details]);

  const handleToggle = (field) => {
    const newValue = !localStatus[field];
    setLocalStatus(prev => ({ ...prev, [field]: newValue }));
    onToggleStatus(field, newValue);
  };

  const renderCommon = () => (
    <>
      <Stack divider={<Divider />} sx={{ flexGrow: 1 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: '0.5em 0' }}>
          <HomeOutlined />
          <Typography sx={{ flex: 1 }}>{t('detailsBody.reserved')}</Typography>
          <Typography sx={{ minWidth: 0, textAlign: 'right', flexShrink: 1, maxWidth: '50%', paddingRight: 1 }}>
            {details.kohteenNimi || t('detailsBody.noInfo')}
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: '0.5em 0' }}>
          <ArrowBackOutlined />
          <Typography sx={{ flex: 1 }}>{t('detailsBody.startTime')}</Typography>
          <Typography sx={{ minWidth: 0, textAlign: 'right', flexShrink: 1, maxWidth: '50%', paddingRight: 1 }}>
            {details.alkuaika ? dayjs(details.alkuaika).format('DD.MM. HH:mm') : t('detailsBody.noInfo')}
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: '0.5em 0' }}>
          <ArrowForwardOutlined />
          <Typography sx={{ flex: 1 }}>{t('detailsBody.endTime')}</Typography>
          <Typography sx={{ minWidth: 0, textAlign: 'right', flexShrink: 1, maxWidth: '50%', paddingRight: 1 }}>
            {details.loppuaika ? dayjs(details.loppuaika).format('DD.MM. HH:mm') : t('detailsBody.noInfo')}
          </Typography>
        </Stack>
      </Stack>
    </>
  );

  return (
    <>
      {renderCommon()}

      {/* omavaraus-only fields */}
      {details.type === 'omavaraus' && (
        <>
          <Divider />

          <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: '0.5em 0' }}>
            <HelpOutline />
            <Typography sx={{ flex: 1 }}>{t('detailsBody.infoFrom')}</Typography>
            <Typography sx={{ minWidth: 0, textAlign: 'right', maxWidth: '50%' }}>
              {details.info1 || t('detailsBody.noInfo')}
            </Typography>
          </Stack>

          <Divider />

          <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: '0.5em 0' }}>
            <InfoOutline />
            <Typography sx={{ flex: 1 }}>INFO:</Typography>
            <Typography sx={{ minWidth: 0, textAlign: 'right', maxWidth: '50%' }}>
              {details.info2 || t('detailsBody.noInfo')}
            </Typography>
          </Stack>
        </>
      )}

      {details.type === 'normivaraus' && (
        <>
          <Divider />
          <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: '0.5em 0' }}>
            <ShoppingCartOutlined />
            <Typography sx={{ flex: 1 }}>
              {t('detailsBody.basket')}
            </Typography>
            <Typography
              sx={{
                minWidth: 0,
                textAlign: 'right',
                flexShrink: 1,
                maxWidth: '50%',
                paddingRight: 1,
              }}
            >
              {details && details.koriId?.id ? details.koriId.id : t('detailsBody.noInfo')}
            </Typography>
          </Stack>
        </>
      )}

      {/* common footer */}
      <Divider />
      <Stack direction="row" alignItems="center" spacing={2} sx={{ padding: '0.5em 0' }}>
        <PeopleOutlined />
        <Typography sx={{ flex: 1 }}>{t('detailsBody.personAmount')}</Typography>
        <Typography sx={{ minWidth: 0, textAlign: 'right', maxWidth: '50%' }}>
          {details?.henkilomaara || t('detailsBody.noInfo')}
        </Typography>
      </Stack>

      <Grid container spacing={1} sx={{ marginTop: '0.5em' }}>
        <Grid size={6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Chip
            label={localStatus.saapunut ? t('detailsBody.arrived') : t('detailsBody.setArrived')}
            color={localStatus.saapunut ? 'success' : 'warning'}
            onClick={!localStatus.lahtenyt ? () => handleToggle('saapunut') : null}
            sx={{ flexGrow: 1 }}
          />
        </Grid>

        <Grid size={6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Chip
            label={localStatus.lahtenyt ? t('detailsBody.departed') : t('detailsBody.setDeparted')}
            color={localStatus.saapunut ? (localStatus.lahtenyt ? 'success' : 'warning') : 'default'}
            onClick={localStatus.saapunut ? () => handleToggle('lahtenyt') : null}
            sx={{ flexGrow: 1 }}
          />
        </Grid>
      </Grid>

      {showSiivous && <SiivousStatus tuoteId={details?.yksikkoId} />}

      {details.type === 'normivaraus' && <Asiakas asiakasData={details.asiakas} />}
    </>
  );
};

export default DetailsBody;
